<div class="d-flex flex-column align-items-center justify-content-center my-2">
    <app-file-drop class="w-100" [extensions]="extensions" (onSelect)="onSelect($event)">
        <div class="my-2 d-flex flex-column align-items-center justify-content-center">
            @if(import.value) {
                <app-icon-file class="mb-3"></app-icon-file>
                <div class="file-name mb-3">{{ import.value.name }}</div>
            }
            <div class="mb-3">Drag & Drop an Excel file here or</div>
            <app-input-file accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" label="+ Choose File" [formControl]="import" [classes]="['btn--purple']"></app-input-file>
        </div>
    </app-file-drop>
</div>
@if(errors.length) {
    <div class="error-list position-relative">
        <div class="error-list--background"></div>
        <div class="error-title mb-3">There are some errors in the selected file “{{ import.value.name }}”. Please make sure the errors are fixed or select another file.</div>
        <div [ngClass]="{'error-list__content': errors.length > 8}" class="position-relative">
            @for(error of errors; track error) {
                <div class="position-relative">{{error}}</div>
            }
        </div>
    </div>
}
